import { signal } from '@angular/core';
import { noop } from 'rxjs';

const deviceVariablesFacadeMock = {
  filteredVariablesAsPlatformResponse: signal({
    currentPage: 0,
    data: [],
    hasMore: false,
    limit: 3000,
    maxPage: 0,
    total: 0
  }),
  groups: signal([]),
  files: signal([]),
  totalVariables: signal(0),
  totalFilteredVariables: signal(0),
  allVariables: signal([]),
  deviceVariablesLoading: signal(false),
  deviceVariablesLoaded: signal(false),
  deviceVariablesTableFilters: signal({}),
  canUpdate: signal(true),
  loadDeviceVariables: () => noop(),
  deleteDeviceVariables: () => noop(),
  resetDeviceVariablesLastValues: () => noop(),
  filterDeviceVariables: () => noop()
};

export function createDeviceVariablesFacadeMock() {
  return {
    ...deviceVariablesFacadeMock,

    loadDeviceVariables: jasmine.createSpy('loadDeviceVariables'),
    deleteDeviceVariables: jasmine.createSpy('deleteDeviceVariables'),
    resetDeviceVariablesLastValues: jasmine.createSpy('resetDeviceVariablesLastValues'),
    filterDeviceVariables: jasmine.createSpy('filterDeviceVariables')
  };
}
